// Takes loop by default — the page is for playing along, and a backing track
// that stops after two minutes stops the practice with it. The button only
// flips the native loop attribute; the audio element stays the player.
//
// Starting one take pauses the others, so two backing tracks never run over
// each other when you jump between them with a guitar in your hands.
document.addEventListener("click", (event) => {
  const button = event.target.closest("[data-loop-toggle]")
  if (!button) return

  const audio = document.getElementById(button.dataset.loopToggle)
  audio.loop = !audio.loop
  button.setAttribute("aria-pressed", String(audio.loop))
})

document.addEventListener("play", (event) => {
  document.querySelectorAll("audio").forEach((audio) => {
    if (audio !== event.target) audio.pause()
  })
}, true)
